export default {
      id: "sli-search-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-search",
      toString: function () {
        return this.url;
      }
    }